import axios from 'axios'
import { hashKey, getTzOffset } from './encrypt'
import { getFromLocalStorage, setToLocalStorage } from '../utils/localStorage'

const apiInstance = axios.create()

apiInstance.interceptors.request.use((config) => {
  config.headers['App'] = window.header
  config.headers['Accept'] = 'application/json'
  const auth = getFromLocalStorage('authorization')
  if (auth) {
    config.headers['Authorization'] = auth
  }
  config.headers['Content-Type'] = 'application/json'
  config.headers['TimeZone'] = getTzOffset()
  config.headers['Authorization'] = '49yfe8hhwrY0UbDvnEX2YS6wdKmyjbdXwaKLXF17ivUCUA9n8ARcbrBvU27NccMm'
  config.headers['module'] = 'googleChatApi'
  config.headers['dr9se2q'] = hashKey({ tzU: new Date().getTime(), appC: '4T2E5RTVX5' }, window.salt)
  config.headers['co1cx2'] = window.iv
  if (!config.url.includes('SSO')) {
    // Remove country ID and code from SSO API
    config.headers['CountryID'] = window.countryID
    config.headers['CountryCode'] = window.countryCode
  }
  config.headers['customheader'] = true
  config.headers['LanguageCode'] = getFromLocalStorage('languageCode')?.code
  return config
})

apiInstance.interceptors.response.use(
  (response) => {
    return response
  },
  (error) => {
    const consumerID = getFromLocalStorage('consumerID')
    const status = error?.status || error?.response?.status
    if (consumerID && status === 401) {
      setToLocalStorage('snackbarDetails', { message: 'Unauthorized user, login again', type: 'error' })
      localStorage.removeItem('consumerID')
      localStorage.removeItem('authorization')
      window.location.replace('/login')
    }
    return Promise.reject(error)
  }
)

export default apiInstance
